import { Pagination } from 'shared/domains/common-ui';
import { useSearchContext } from '../SearchProvider';
export function SearchResultsPagination(props) {
    const { totalCount, limit, disabled } = props;
    const { resultOffset, setResultOffset } = useSearchContext();
    return (<Pagination count={totalCount} maxCount={10000} limit={limit} offset={resultOffset} setOffset={setResultOffset} disabled={disabled}/>);
}
